export const items = [];

const jobCategories = {
  "n": [
    {
      "des": "管理幕僚／人資／行政",
      "no": "100000",
      "n": [
        {
          "des": "管理幕僚",
          "no": "100100",
          "n": [
            {
              "des": "經營管理主管",
              "no": "100101"
            },
            {
              "des": "特別助理",
              "no": "100105"
            },
            {
              "des": "高階秘書",
              "no": "100106"
            },
            {
              "des": "基層管理幹部",
              "no": "100107"
            },
            {
              "des": "儲備幹部",
              "no": "100108"
            },
            {
              "des": "主管駕駛",
              "no": "100109"
            }
          ]
        },
        {
          "des": "人力資源",
          "no": "100200",
          "n": [
            {
              "des": "人事／人力資源主管",
              "no": "100201"
            },
            {
              "des": "人事／人力資源專員",
              "no": "100202"
            },
            {
              "des": "人力／外勞仲介",
              "no": "100203"
            },
            {
              "des": "教育訓練人員",
              "no": "100204"
            },
            {
              "des": "人事助理",
              "no": "100205"
            }
          ]
        },
        {
          "des": "行政後勤／總務",
          "no": "100300",
          "n": [
            {
              "des": "行政主管",
              "no": "100301"
            },
            {
              "des": "行政人員",
              "no": "100302"
            },
            {
              "des": "秘書",
              "no": "100303"
            },
            {
              "des": "行政助理",
              "no": "100304"
            },
            {
              "des": "總務主管",
              "no": "100305"
            },
            {
              "des": "總務人員",
              "no": "100306"
            },
            {
              "des": "總機／接待／櫃檯人員",
              "no": "100307"
            },
            {
              "des": "檔案資料管理人員",
              "no": "100308"
            },
            {
              "des": "電腦操作／資料輸入",
              "no": "100309"
            },
            {
              "des": "工讀生",
              "no": "100310"
            },
            {
              "des": "文件管理師",
              "no": "100311"
            }
          ]
        }
      ]
    },
    {
      "des": "金融保險／財會／稽核",
      "no": "110000",
      "n": [
        {
          "des": "金融保險",
          "no": "110100",
          "n": [
            {
              "des": "金融專業主管",
              "no": "110101"
            },
            {
              "des": "金融研究人員",
              "no": "110102"
            },
            {
              "des": "不動產審核／估價師",
              "no": "110103"
            },
            {
              "des": "授權／授信／徵信人員",
              "no": "110104"
            },
            {
              "des": "金融營業人員",
              "no": "110105"
            },
            {
              "des": "銀行辦事人員",
              "no": "110106"
            },
            {
              "des": "投資理財人員",
              "no": "110107"
            },
            {
              "des": "帳款催收人員",
              "no": "110108"
            },
            {
              "des": "股務人員",
              "no": "110109"
            },
            {
              "des": "承銷人員",
              "no": "110110"
            },
            {
              "des": "券商後線人員",
              "no": "110111"
            },
            {
              "des": "統計精算人員",
              "no": "110112"
            },
            {
              "des": "理賠人員",
              "no": "110113"
            },
            {
              "des": "核保／保險內勤人員",
              "no": "110114"
            }
          ]
        },
        {
          "des": "財務會計",
          "no": "110200",
          "n": [
            {
              "des": "財務／會計主管",
              "no": "110201"
            },
            {
              "des": "主辦會計",
              "no": "110202"
            },
            {
              "des": "財務分析人員",
              "no": "110203"
            },
            {
              "des": "成本會計人員",
              "no": "110204"
            },
            {
              "des": "財務人員",
              "no": "110205"
            },
            {
              "des": "會計／出納／記帳人員",
              "no": "110206"
            },
            {
              "des": "財務／會計助理",
              "no": "110207"
            }
          ]
        },
        {
          "des": "稽核審計",
          "no": "110300",
          "n": [
            {
              "des": "會計師",
              "no": "110301"
            },
            {
              "des": "稽核主管",
              "no": "110302"
            },
            {
              "des": "稽核人員",
              "no": "110303"
            },
            {
              "des": "查帳／審計人員",
              "no": "110304"
            },
            {
              "des": "稅務人員",
              "no": "110305"
            }
          ]
        }
      ]
    },
    {
      "des": "業務／貿易／客服／門市",
      "no": "120000",
      "n": [
        {
          "des": "國際貿易",
          "no": "120100",
          "n": [
            {
              "des": "國貿人員",
              "no": "120101"
            },
            {
              "des": "國貿助理",
              "no": "120102"
            },
            {
              "des": "保稅人員",
              "no": "120103"
            },
            {
              "des": "船務",
              "no": "120104"
            },
            {
              "des": "報關人員",
              "no": "120105"
            }
          ]
        },
        {
          "des": "業務推廣",
          "no": "120200",
          "n": [
            {
              "des": "國內業務主管",
              "no": "120201"
            },
            {
              "des": "國外業務主管",
              "no": "120202"
            },
            {
              "des": "國內業務人員",
              "no": "120203"
            },
            {
              "des": "國外業務人員",
              "no": "120204"
            },
            {
              "des": "專案業務主管",
              "no": "120205"
            },
            {
              "des": "業務工程師",
              "no": "120206"
            },
            {
              "des": "業務助理",
              "no": "120207"
            },
            {
              "des": "電話行銷主管",
              "no": "120208"
            },
            {
              "des": "電話行銷人員",
              "no": "120209"
            },
            {
              "des": "融資／信用業務人員",
              "no": "120210"
            },
            {
              "des": "醫藥業務代表",
              "no": "120211"
            },
            {
              "des": "不動產經紀人／營業員",
              "no": "120212"
            },
            {
              "des": "保險業務員／經紀人",
              "no": "120213"
            },
            {
              "des": "廣告AE",
              "no": "120214"
            },
            {
              "des": "汽車銷售人員",
              "no": "120215"
            },
            {
              "des": "信用卡類人員",
              "no": "120216"
            },
            {
              "des": "補習班招生人員",
              "no": "120217"
            },
            {
              "des": "傳直銷人員",
              "no": "120218"
            },
            {
              "des": "加盟／招商人員",
              "no": "120220"
            },
            {
              "des": "通路開發人員",
              "no": "120221"
            },
            {
              "des": "商品開發人員",
              "no": "120222"
            },
            {
              "des": "駐校代表",
              "no": "120223"
            },
            {
              "des": "內勤業務",
              "no": "120224"
            }
          ]
        },
        {
          "des": "客服開發",
          "no": "120300",
          "n": [
            {
              "des": "客服主管",
              "no": "120301"
            },
            {
              "des": "客服工程師",
              "no": "120302"
            },
            {
              "des": "客服人員",
              "no": "120303"
            },
            {
              "des": "電訪人員",
              "no": "120304"
            },
            {
              "des": "電話客服人員",
              "no": "120305"
            },
            {
              "des": "客戶成功經理",
              "no": "120306"
            }
          ]
        },
        {
          "des": "門市銷售",
          "no": "120400",
          "n": [
            {
              "des": "店長／門市管理人員",
              "no": "120401"
            },
            {
              "des": "大型賣場管理人員",
              "no": "120402"
            },
            {
              "des": "門市／店員／專櫃人員",
              "no": "120403"
            },
            {
              "des": "售票／收銀人員",
              "no": "120404"
            },
            {
              "des": "駐點銷售人員",
              "no": "120405"
            },
            {
              "des": "樓面管理人員",
              "no": "120406"
            }
          ]
        }
      ]
    },
    {
      "des": "行銷／企劃／專案管理",
      "no": "130000",
      "n": [
        {
          "des": "行銷／廣告",
          "no": "130100",
          "n": [
            {
              "des": "廣告／行銷企劃主管",
              "no": "130101"
            },
            {
              "des": "行銷企劃人員",
              "no": "130103"
            },
            {
              "des": "廣告文案企劃人員",
              "no": "130104"
            },
            {
              "des": "廣告採購人員",
              "no": "130108"
            },
            {
              "des": "行銷企劃助理",
              "no": "130109"
            },
            {
              "des": "社群經營人員",
              "no": "130110"
            },
            {
              "des": "數位行銷人員",
              "no": "130111"
            }
          ]
        },
        {
          "des": "產品／企劃",
          "no": "130200",
          "n": [
            {
              "des": "公關企劃人員",
              "no": "130201"
            },
            {
              "des": "活動企劃人員",
              "no": "130202"
            },
            {
              "des": "婚禮企劃人員",
              "no": "130203"
            },
            {
              "des": "市場調查／分析人員",
              "no": "130204"
            },
            {
              "des": "策展人",
              "no": "130205"
            },
            {
              "des": "產品企劃主管",
              "no": "130206"
            },
            {
              "des": "遊戲企劃人員",
              "no": "130207"
            },
            {
              "des": "產品企劃人員",
              "no": "130208"
            },
            {
              "des": "網站企劃人員",
              "no": "130209"
            },
            {
              "des": "產品經理",
              "no": "130210"
            }
          ]
        },
        {
          "des": "專案管理",
          "no": "130300",
          "n": [
            {
              "des": "專案管理主管",
              "no": "130301"
            },
            {
              "des": "ERP專案管理師",
              "no": "130302"
            },
            {
              "des": "軟體相關管理師",
              "no": "130303"
            },
            {
              "des": "產品管理師",
              "no": "130304"
            },
            {
              "des": "其他專案管理師",
              "no": "130305"
            },
            {
              "des": "ESG永續管理師",
              "no": "130306"
            },
            {
              "des": "專案經理",
              "no": "130307"
            }
          ]
        }
      ]
    },
    {
      "des": "電腦系統／資訊／軟硬體",
      "no": "140000",
      "n": [
        {
          "des": "電腦硬體",
          "no": "140100",
          "n": [
            {
              "des": "電腦硬體研發工程師",
              "no": "140101"
            },
            {
              "des": "電腦組裝／維修",
              "no": "140102"
            },
            {
              "des": "網路及電信線路架設人員",
              "no": "140103"
            },
            {
              "des": "硬體工程研發主管",
              "no": "140104"
            }
          ]
        },
        {
          "des": "軟體工程",
          "no": "140200",
          "n": [
            {
              "des": "軟體專案主管",
              "no": "140201"
            },
            {
              "des": "軟體工程師",
              "no": "140202"
            },
            {
              "des": "通訊軟體工程師",
              "no": "140203"
            },
            {
              "des": "韌體研發類主管",
              "no": "140204"
            },
            {
              "des": "韌體工程師",
              "no": "140205"
            },
            {
              "des": "軟／韌體測試人員",
              "no": "140206"
            },
            {
              "des": "BIOS工程師",
              "no": "140208"
            },
            {
              "des": "CIM工程師",
              "no": "140209"
            },
            {
              "des": "MES工程師",
              "no": "140210"
            },
            {
              "des": "網站技術主管",
              "no": "140211"
            },
            {
              "des": "網站程式設計師",
              "no": "140213"
            }
          ]
        },
        {
          "des": "系統規劃",
          "no": "140300",
          "n": [
            {
              "des": "系統工程師",
              "no": "140301"
            },
            {
              "des": "系統分析師",
              "no": "140302"
            },
            {
              "des": "系統維護員／操作員",
              "no": "140303"
            },
            {
              "des": "助理工程師",
              "no": "140305"
            },
            {
              "des": "電子商務技術主管",
              "no": "140306"
            }
          ]
        },
        {
          "des": "網路管理",
          "no": "140400",
          "n": [
            {
              "des": "MIS／網管主管",
              "no": "140401"
            },
            {
              "des": "MIS工程師",
              "no": "140402"
            },
            {
              "des": "網路管理工程師",
              "no": "140403"
            },
            {
              "des": "資訊助理人員",
              "no": "140405"
            }
          ]
        },
        {
          "des": "資料科學",
          "no": "140500",
          "n": [
            {
              "des": "資料科學工程主管",
              "no": "140501"
            },
            {
              "des": "數據科學家",
              "no": "140502"
            },
            {
              "des": "數據分析師",
              "no": "140503"
            },
            {
              "des": "數據管理師",
              "no": "140504"
            },
            {
              "des": "數據架構師",
              "no": "140505"
            },
            {
              "des": "數據工程師",
              "no": "140506"
            },
            {
              "des": "商業分析師",
              "no": "140507"
            },
            {
              "des": "機器學習工程師",
              "no": "140508"
            },
            {
              "des": "演算法開發工程師",
              "no": "140509"
            },
            {
              "des": "統計分析師",
              "no": "140510"
            },
            {
              "des": "數據建模工程師",
              "no": "140511"
            },
            {
              "des": "臨床數據管理師",
              "no": "140512"
            },
            {
              "des": "市場分析師",
              "no": "140513"
            },
            {
              "des": "資料科學助理工程師",
              "no": "140514"
            },
            {
              "des": "資料庫管理人員",
              "no": "140515"
            }
          ]
        },
        {
          "des": "雲服務/雲計算",
          "no": "140600",
          "n": [
            {
              "des": "雲服務/雲計算工程主管",
              "no": "140601"
            },
            {
              "des": "雲端系統管理員",
              "no": "140602"
            },
            {
              "des": "雲端架構師",
              "no": "140603"
            },
            {
              "des": "雲端工程師",
              "no": "140604"
            },
            {
              "des": "雲端資安管理師",
              "no": "140605"
            },
            {
              "des": "雲端應用工程師",
              "no": "140606"
            },
            {
              "des": "雲端網路工程師",
              "no": "140607"
            },
            {
              "des": "雲端自動化工程師",
              "no": "140608"
            },
            {
              "des": "雲服務/雲計算助理工程師",
              "no": "140609"
            }
          ]
        },
        {
          "des": "資訊安全",
          "no": "140700",
          "n": [
            {
              "des": "網路風險管理主管",
              "no": "140701"
            },
            {
              "des": "資訊安全架構師",
              "no": "140702"
            },
            {
              "des": "資訊威脅分析師",
              "no": "140703"
            },
            {
              "des": "資訊安全運營工程師",
              "no": "140704"
            },
            {
              "des": "漏洞評估滲透測試工程師",
              "no": "140705"
            },
            {
              "des": "網路資安工程師",
              "no": "140706"
            },
            {
              "des": "密碼學專家",
              "no": "140707"
            },
            {
              "des": "資安長",
              "no": "140708"
            },
            {
              "des": "資安風險管理師",
              "no": "140709"
            },
            {
              "des": "資安法遵師",
              "no": "140710"
            },
            {
              "des": "資安稽核師",
              "no": "140711"
            },
            {
              "des": "資安教育員",
              "no": "140712"
            },
            {
              "des": "資安系統規劃師",
              "no": "140713"
            },
            {
              "des": "資安顧問師",
              "no": "140714"
            },
            {
              "des": "資安監控防禦工程師",
              "no": "140715"
            }
          ]
        },
        {
          "des": "系統發展",
          "no": "140800",
          "n": [
            {
              "des": "系統開發主管",
              "no": "140801"
            },
            {
              "des": "前端開發工程師",
              "no": "140802"
            },
            {
              "des": "後端開發工程師",
              "no": "140803"
            },
            {
              "des": "全端開發工程師",
              "no": "140804"
            },
            {
              "des": "DevOps開發工程師",
              "no": "140805"
            },
            {
              "des": "區塊鏈開發工程師",
              "no": "140806"
            },
            {
              "des": "嵌入式開發工程師",
              "no": "140807"
            },
            {
              "des": "自動化測試開發工程師",
              "no": "140808"
            },
            {
              "des": "電玩開發工程師",
              "no": "140809"
            },
            {
              "des": "APP開發工程師",
              "no": "140810"
            }
          ]
        }
      ]
    },
    {
      "des": "光電IC／電子通訊",
      "no": "150000",
      "n": [
        {
          "des": "電子通訊",
          "no": "150100",
          "n": [
            {
              "des": "通訊工程研發主管",
              "no": "150101"
            },
            {
              "des": "電信／通訊系統工程師",
              "no": "150102"
            },
            {
              "des": "RF通訊工程師",
              "no": "150103"
            },
            {
              "des": "電子工程主管",
              "no": "150104"
            },
            {
              "des": "電子工程師",
              "no": "150105"
            },
            {
              "des": "電源工程師",
              "no": "150106"
            },
            {
              "des": "零組件工程師",
              "no": "150107"
            },
            {
              "des": "SMT工程師",
              "no": "150108"
            },
            {
              "des": "PCB-Layout佈局工程師",
              "no": "150110"
            },
            {
              "des": "電子／通訊工程助理",
              "no": "150111"
            }
          ]
        },
        {
          "des": "光電半導體",
          "no": "150200",
          "n": [
            {
              "des": "半導體工程研發主管",
              "no": "150201"
            },
            {
              "des": "半導體工程師",
              "no": "150202"
            },
            {
              "des": "半導體製程工程師",
              "no": "150203"
            },
            {
              "des": "半導體設備工程師",
              "no": "150204"
            },
            {
              "des": "IC設計工程師",
              "no": "150205"
            },
            {
              "des": "類比IC設計工程師",
              "no": "150206"
            },
            {
              "des": "數位IC設計工程師",
              "no": "150207"
            },
            {
              "des": "IC佈局工程師",
              "no": "150208"
            },
            {
              "des": "IC封裝／測試工程師",
              "no": "150209"
            },
            {
              "des": "光電工程研發主管",
              "no": "150210"
            },
            {
              "des": "光電工程師",
              "no": "150211"
            },
            {
              "des": "太陽能技術工程師",
              "no": "150212"
            },
            {
              "des": "光學工程師",
              "no": "150213"
            },
            {
              "des": "光電製程工程師",
              "no": "150214"
            },
            {
              "des": "光電設備工程師",
              "no": "150215"
            },
            {
              "des": "光電／半導體工程助理",
              "no": "150216"
            }
          ]
        }
      ]
    },
    {
      "des": "機械模具／生產製程",
      "no": "160000",
      "n": [
        {
          "des": "機械工程",
          "no": "160100",
          "n": [
            {
              "des": "機械工程主管",
              "no": "160101"
            },
            {
              "des": "汽車研發人員",
              "no": "160102"
            },
            {
              "des": "電機工程主管",
              "no": "160103"
            },
            {
              "des": "電機技師／工程師",
              "no": "160104"
            },
            {
              "des": "電機維修人員",
              "no": "160106"
            },
            {
              "des": "機電技師／工程師",
              "no": "160107"
            },
            {
              "des": "微機電工程師",
              "no": "160108"
            },
            {
              "des": "機構工程師",
              "no": "160109"
            },
            {
              "des": "機械工程師",
              "no": "160110"
            },
            {
              "des": "熱傳工程師",
              "no": "160111"
            },
            {
              "des": "聲學／噪音工程師",
              "no": "160112"
            },
            {
              "des": "其他特殊工程人員",
              "no": "160113"
            },
            {
              "des": "機械設計／繪圖人員",
              "no": "160114"
            },
            {
              "des": "工程助理",
              "no": "160115"
            },
            {
              "des": "電機設備裝配員",
              "no": "160116"
            }
          ]
        },
        {
          "des": "生產製程",
          "no": "160200",
          "n": [
            {
              "des": "工廠高階主管",
              "no": "160201"
            },
            {
              "des": "生管主管",
              "no": "160202"
            },
            {
              "des": "製程主管",
              "no": "160203"
            },
            {
              "des": "設備工程主管",
              "no": "160204"
            },
            {
              "des": "領班／管理幹部",
              "no": "160205"
            },
            {
              "des": "生產技術／製程工程師",
              "no": "160206"
            },
            {
              "des": "生產設備工程師",
              "no": "160207"
            },
            {
              "des": "生產線工程師",
              "no": "160208"
            },
            {
              "des": "工業工程師",
              "no": "160209"
            },
            {
              "des": "紡織工務",
              "no": "160210"
            },
            {
              "des": "廠務／助理",
              "no": "160211"
            },
            {
              "des": "生管／助理",
              "no": "160212"
            },
            {
              "des": "包裝員／作業員",
              "no": "160213"
            },
            {
              "des": "PLC／自動控制工程師",
              "no": "160214"
            },
            {
              "des": "環境分析研究員",
              "no": "160215"
            },
            {
              "des": "儀器操作分析員",
              "no": "160216"
            }
          ]
        },
        {
          "des": "模具相關",
          "no": "160300",
          "n": [
            {
              "des": "CAD／CAM工程師",
              "no": "160301"
            },
            {
              "des": "模具技術人員",
              "no": "160302"
            },
            {
              "des": "塑膠模具技術人員",
              "no": "160303"
            },
            {
              "des": "金屬模具技術人員",
              "no": "160304"
            },
            {
              "des": "沖壓模具技術人員",
              "no": "160305"
            },
            {
              "des": "壓鑄模具技術人員",
              "no": "160306"
            },
            {
              "des": "鑄造／鍛造模具技術人員",
              "no": "160307"
            },
            {
              "des": "粉末冶金模具技術人員",
              "no": "160308"
            },
            {
              "des": "塑膠射出技術人員",
              "no": "160309"
            },
            {
              "des": "塑膠押出技術人員",
              "no": "160310"
            }
          ]
        }
      ]
    },
    {
      "des": "操作／維修／技術服務",
      "no": "170000",
      "n": [
        {
          "des": "工具機加工",
          "no": "170100",
          "n": [
            {
              "des": "CNC程式設計師",
              "no": "170101"
            },
            {
              "des": "CNC車床人員",
              "no": "170102"
            },
            {
              "des": "CNC銑床人員",
              "no": "170103"
            },
            {
              "des": "雷射技術操作員",
              "no": "170104"
            },
            {
              "des": "拋光／研磨技術人員",
              "no": "170105"
            },
            {
              "des": "沖床人員",
              "no": "170106"
            },
            {
              "des": "傳統車床人員",
              "no": "170107"
            },
            {
              "des": "傳統銑床人員",
              "no": "170108"
            },
            {
              "des": "線切割技術人員",
              "no": "170109"
            },
            {
              "des": "放電加工技術人員",
              "no": "170110"
            }
          ]
        },
        {
          "des": "操作技術",
          "no": "170200",
          "n": [
            {
              "des": "環保／環境工程師／技師",
              "no": "170201"
            },
            {
              "des": "電鍍相關技術人員",
              "no": "170202"
            },
            {
              "des": "機械加工技術人員",
              "no": "170203"
            },
            {
              "des": "組裝組立技術人員",
              "no": "170204"
            },
            {
              "des": "印前製作人員",
              "no": "170205"
            },
            {
              "des": "印刷技術人員",
              "no": "170206"
            },
            {
              "des": "鈑金技術人員",
              "no": "170207"
            },
            {
              "des": "焊接技術人員",
              "no": "170208"
            },
            {
              "des": "塗裝技術人員",
              "no": "170209"
            },
            {
              "des": "鉗工",
              "no": "170210"
            },
            {
              "des": "技術人員",
              "no": "170211"
            },
            {
              "des": "堆高機操作人員",
              "no": "170212"
            },
            {
              "des": "機械操作人員",
              "no": "170213"
            },
            {
              "des": "製鞋類人員",
              "no": "170214"
            },
            {
              "des": "車縫人員",
              "no": "170215"
            },
            {
              "des": "學徒",
              "no": "170216"
            },
            {
              "des": "PCB技術人員",
              "no": "170217"
            },
            {
              "des": "噴漆技術人員",
              "no": "170218"
            },
            {
              "des": "染印人員",
              "no": "170219"
            },
            {
              "des": "鍋爐相關人員",
              "no": "170220"
            },
            {
              "des": "大圖輸出後製人員",
              "no": "170221"
            }
          ]
        },
        {
          "des": "維修／技術服務",
          "no": "170300",
          "n": [
            {
              "des": "維修技術主管",
              "no": "170301"
            },
            {
              "des": "技術支援主管",
              "no": "170302"
            },
            {
              "des": "通信維修人員",
              "no": "170303"
            },
            {
              "des": "產品設備維修人員",
              "no": "170304"
            },
            {
              "des": "電器產品維修人員",
              "no": "170305"
            },
            {
              "des": "電子設備維修人員",
              "no": "170306"
            },
            {
              "des": "精密儀器製造維修人員",
              "no": "170307"
            },
            {
              "des": "飛機修護員",
              "no": "170308"
            },
            {
              "des": "汽車維修人員",
              "no": "170309"
            },
            {
              "des": "汽車引擎技術人員",
              "no": "170310"
            },
            {
              "des": "其他車輛維修人員",
              "no": "170311"
            },
            {
              "des": "機車維修人員",
              "no": "170312"
            },
            {
              "des": "機械設備組裝測試人員",
              "no": "170313"
            },
            {
              "des": "冷凍空調技術人員／安裝員",
              "no": "170314"
            },
            {
              "des": "FAE工程師",
              "no": "170315"
            },
            {
              "des": "維修技術人員",
              "no": "170316"
            }
          ]
        }
      ]
    },
    {
      "des": "採購／物流／品質檢測",
      "no": "180000",
      "n": [
        {
          "des": "採購資材",
          "no": "180100",
          "n": [
            {
              "des": "採購主管",
              "no": "180101"
            },
            {
              "des": "資材主管",
              "no": "180102"
            },
            {
              "des": "採購人員",
              "no": "180103"
            },
            {
              "des": "資材人員",
              "no": "180104"
            },
            {
              "des": "倉管／物料管理員",
              "no": "180105"
            },
            {
              "des": "採購助理",
              "no": "180106"
            },
            {
              "des": "材料分析員",
              "no": "180107"
            }
          ]
        },
        {
          "des": "運輸物流",
          "no": "180200",
          "n": [
            {
              "des": "運輸物流類主管",
              "no": "180201"
            },
            {
              "des": "飛行機師",
              "no": "180202"
            },
            {
              "des": "飛安人員",
              "no": "180203"
            },
            {
              "des": "船上作業人員",
              "no": "180204"
            },
            {
              "des": "倉儲物流人員",
              "no": "180205"
            },
            {
              "des": "運輸調度管理人員",
              "no": "180206"
            },
            {
              "des": "大客車司機",
              "no": "180207"
            },
            {
              "des": "小客車／小貨車司機",
              "no": "180208"
            },
            {
              "des": "空服人員",
              "no": "180209"
            },
            {
              "des": "地勤人員",
              "no": "180210"
            },
            {
              "des": "外務／快遞／送貨",
              "no": "180211"
            },
            {
              "des": "聯結車司機",
              "no": "180212"
            },
            {
              "des": "艙面部船員",
              "no": "180213"
            },
            {
              "des": "輪機部船員",
              "no": "180214"
            },
            {
              "des": "事務部船員",
              "no": "180215"
            },
            {
              "des": "大貨車司機",
              "no": "180216"
            },
            {
              "des": "隨車人員",
              "no": "180217"
            }
          ]
        },
        {
          "des": "品管品保",
          "no": "180300",
          "n": [
            {
              "des": "品管／品保主管",
              "no": "180301"
            },
            {
              "des": "職業安全衛生管理人員",
              "no": "180302"
            },
            {
              "des": "工廠安全衛生人員",
              "no": "180303"
            },
            {
              "des": "食品衛生管理師",
              "no": "180304"
            },
            {
              "des": "EMC／安規工程人員",
              "no": "180305"
            },
            {
              "des": "可靠度工程師",
              "no": "180306"
            },
            {
              "des": "品保工程師",
              "no": "180307"
            },
            {
              "des": "測試工程師",
              "no": "180308"
            },
            {
              "des": "故障分析工程師",
              "no": "180309"
            },
            {
              "des": "品管人員",
              "no": "180310"
            },
            {
              "des": "ISO品保人員",
              "no": "180311"
            },
            {
              "des": "食品檢驗人員",
              "no": "180312"
            },
            {
              "des": "檢驗人員",
              "no": "180313"
            },
            {
              "des": "公共衛生人員",
              "no": "180314"
            },
            {
              "des": "汽車檢驗員",
              "no": "180315"
            },
            {
              "des": "原料檢驗人員",
              "no": "180316"
            }
          ]
        }
      ]
    },
    {
      "des": "營建／製圖／施作",
      "no": "190000",
      "n": [
        {
          "des": "營建規劃",
          "no": "190100",
          "n": [
            {
              "des": "建築師",
              "no": "190101"
            },
            {
              "des": "營建主管",
              "no": "190102"
            },
            {
              "des": "建築繪圖／設計",
              "no": "190103"
            },
            {
              "des": "土地開發人員",
              "no": "190104"
            },
            {
              "des": "估算人員",
              "no": "190105"
            },
            {
              "des": "發包人員",
              "no": "190106"
            },
            {
              "des": "內業工程人員",
              "no": "190107"
            },
            {
              "des": "水土保持技師",
              "no": "190108"
            },
            {
              "des": "土木技師／工程師",
              "no": "190109"
            },
            {
              "des": "結構技師／工程師",
              "no": "190110"
            },
            {
              "des": "都市／交通規劃人員",
              "no": "190111"
            },
            {
              "des": "水利工程師",
              "no": "190112"
            },
            {
              "des": "水電工程師",
              "no": "190113"
            },
            {
              "des": "電信／配線繪圖",
              "no": "190114"
            },
            {
              "des": "冷凍空調繪圖／設計",
              "no": "190115"
            },
            {
              "des": "水電及其他工程繪圖人員",
              "no": "190116"
            },
            {
              "des": "室內設計師",
              "no": "190117"
            },
            {
              "des": "景觀設計人員",
              "no": "190118"
            },
            {
              "des": "櫥窗／會場設計人員",
              "no": "190119"
            },
            {
              "des": "消防繪圖人員",
              "no": "190120"
            }
          ]
        },
        {
          "des": "營造施作",
          "no": "190200",
          "n": [
            {
              "des": "工地主管／主任",
              "no": "190201"
            },
            {
              "des": "工地品管員／工程師",
              "no": "190202"
            },
            {
              "des": "工地安全衛生工程師",
              "no": "190203"
            },
            {
              "des": "現場規劃工程師",
              "no": "190204"
            },
            {
              "des": "工務助理",
              "no": "190205"
            },
            {
              "des": "工務工管人員",
              "no": "190206"
            },
            {
              "des": "工地監工",
              "no": "190207"
            },
            {
              "des": "營建工程人員",
              "no": "190208"
            },
            {
              "des": "測量／儀校人員",
              "no": "190209"
            },
            {
              "des": "模板工程人員",
              "no": "190210"
            },
            {
              "des": "泥水工相關人員",
              "no": "190211"
            },
            {
              "des": "挖土／推土機相關操作人員",
              "no": "190212"
            },
            {
              "des": "吊車／起重機相關操作人員",
              "no": "190213"
            },
            {
              "des": "重機械操作人員",
              "no": "190214"
            },
            {
              "des": "營建雜工／粗工",
              "no": "190215"
            },
            {
              "des": "水電工",
              "no": "190216"
            },
            {
              "des": "金屬建材架構人員",
              "no": "190217"
            },
            {
              "des": "防水施工人員",
              "no": "190218"
            },
            {
              "des": "裝潢工程人員",
              "no": "190219"
            },
            {
              "des": "木工",
              "no": "190220"
            },
            {
              "des": "油漆工",
              "no": "190221"
            },
            {
              "des": "建築物清潔人員",
              "no": "190222"
            }
          ]
        }
      ]
    },
    {
      "des": "醫療／護理／保健",
      "no": "200000",
      "n": [
        {
          "des": "醫事人員",
          "no": "200100",
          "n": [
            {
              "des": "醫師",
              "no": "200101"
            },
            {
              "des": "牙醫師",
              "no": "200102"
            },
            {
              "des": "中醫師",
              "no": "200103"
            },
            {
              "des": "醫學美容／整型",
              "no": "200104"
            },
            {
              "des": "麻醉醫師",
              "no": "200105"
            },
            {
              "des": "臨床／諮商心理師",
              "no": "200106"
            },
            {
              "des": "職能治療師",
              "no": "200107"
            },
            {
              "des": "物理治療師",
              "no": "200108"
            },
            {
              "des": "語言治療師",
              "no": "200109"
            },
            {
              "des": "呼吸治療師",
              "no": "200110"
            },
            {
              "des": "獸醫／獸醫佐",
              "no": "200111"
            },
            {
              "des": "其他醫療從業人員",
              "no": "200112"
            },
            {
              "des": "藥師",
              "no": "200113"
            }
          ]
        },
        {
          "des": "醫事保健",
          "no": "200200",
          "n": [
            {
              "des": "營養師",
              "no": "200202"
            },
            {
              "des": "醫事檢驗師",
              "no": "200203"
            },
            {
              "des": "復健技術師",
              "no": "200204"
            },
            {
              "des": "醫事放射師",
              "no": "200205"
            },
            {
              "des": "驗光師",
              "no": "200206"
            },
            {
              "des": "牙體技術人員",
              "no": "200207"
            },
            {
              "des": "推拿／按摩師",
              "no": "200208"
            },
            {
              "des": "放射性設備使用技術員",
              "no": "200209"
            }
          ]
        },
        {
          "des": "醫務護理",
          "no": "200300",
          "n": [
            {
              "des": "護理長",
              "no": "200301"
            },
            {
              "des": "護理師",
              "no": "200302"
            },
            {
              "des": "專科護理師",
              "no": "200303"
            },
            {
              "des": "照顧服務員",
              "no": "200304"
            },
            {
              "des": "勞工健康服務護理人員／廠護",
              "no": "200305"
            },
            {
              "des": "居家服務督導員",
              "no": "200306"
            },
            {
              "des": "個案管理師",
              "no": "200307"
            },
            {
              "des": "照顧指導員",
              "no": "200308"
            },
            {
              "des": "專任管理員",
              "no": "200309"
            }
          ]
        },
        {
          "des": "醫務行政",
          "no": "200400",
          "n": [
            {
              "des": "藥師助理",
              "no": "200401"
            },
            {
              "des": "診所助理",
              "no": "200402"
            },
            {
              "des": "牙醫助理",
              "no": "200403"
            },
            {
              "des": "醫院行政管理人員",
              "no": "200404"
            }
          ]
        }
      ]
    },
    {
      "des": "生物科技／化學製藥",
      "no": "210000",
      "n": [
        {
          "des": "醫藥生技",
          "no": "210100",
          "n": [
            {
              "des": "生技主管",
              "no": "210101"
            },
            {
              "des": "醫藥研發人員",
              "no": "210102"
            },
            {
              "des": "病理藥理研究人員",
              "no": "210103"
            },
            {
              "des": "生物科技研發人員",
              "no": "210104"
            },
            {
              "des": "醫療器材研發工程師",
              "no": "210105"
            },
            {
              "des": "微生物分析師",
              "no": "210106"
            }
          ]
        },
        {
          "des": "化工實驗",
          "no": "210200",
          "n": [
            {
              "des": "化學／化工工程師",
              "no": "210201"
            },
            {
              "des": "奈米研發工程師",
              "no": "210202"
            },
            {
              "des": "特用化學工程師",
              "no": "210203"
            },
            {
              "des": "紡織化學工程師",
              "no": "210204"
            },
            {
              "des": "材料研發人員",
              "no": "210205"
            },
            {
              "des": "食品研發人員",
              "no": "210206"
            },
            {
              "des": "實驗／化驗人員",
              "no": "210207"
            }
          ]
        }
      ]
    },
    {
      "des": "影視傳媒／出版翻譯",
      "no": "220000",
      "n": [
        {
          "des": "新聞媒體",
          "no": "220100",
          "n": [
            {
              "des": "新聞／傳播媒體主管",
              "no": "220101"
            },
            {
              "des": "媒體公關主管",
              "no": "220102"
            },
            {
              "des": "傳播媒體編輯企劃",
              "no": "220103"
            },
            {
              "des": "播報人員",
              "no": "220104"
            },
            {
              "des": "攝影記者",
              "no": "220105"
            },
            {
              "des": "文字記者",
              "no": "220106"
            },
            {
              "des": "媒體公關人員",
              "no": "220107"
            }
          ]
        },
        {
          "des": "影視演藝",
          "no": "220200",
          "n": [
            {
              "des": "演藝經紀／宣傳人員",
              "no": "220201"
            },
            {
              "des": "表演／主持／直播人員",
              "no": "220202"
            },
            {
              "des": "模特兒",
              "no": "220203"
            },
            {
              "des": "演員",
              "no": "220204"
            },
            {
              "des": "聲樂及演唱家",
              "no": "220205"
            },
            {
              "des": "樂器演奏／合成音樂",
              "no": "220206"
            },
            {
              "des": "舞蹈演藝人員",
              "no": "220207"
            }
          ]
        },
        {
          "des": "幕後執行",
          "no": "220300",
          "n": [
            {
              "des": "導演／導播",
              "no": "220301"
            },
            {
              "des": "編劇及詞曲創作",
              "no": "220302"
            },
            {
              "des": "藝術指導／藝術總監",
              "no": "220303"
            },
            {
              "des": "執行製作／助理",
              "no": "220304"
            },
            {
              "des": "攝影師",
              "no": "220305"
            },
            {
              "des": "微波工程師",
              "no": "220306"
            },
            {
              "des": "影片製作技術人員",
              "no": "220307"
            },
            {
              "des": "剪輯師",
              "no": "220308"
            },
            {
              "des": "配音人員",
              "no": "220309"
            },
            {
              "des": "字幕人員",
              "no": "220310"
            },
            {
              "des": "棚內技術工程人員",
              "no": "220311"
            },
            {
              "des": "舞台搭設工程人員",
              "no": "220312"
            },
            {
              "des": "燈光技術人員",
              "no": "220313"
            },
            {
              "des": "音響／音控技術人員",
              "no": "220314"
            },
            {
              "des": "攝影助理",
              "no": "220315"
            }
          ]
        },
        {
          "des": "出版翻譯",
          "no": "220400",
          "n": [
            {
              "des": "編採主管",
              "no": "220401"
            },
            {
              "des": "發行企劃／出版人員",
              "no": "220402"
            },
            {
              "des": "教材編輯人員",
              "no": "220403"
            },
            {
              "des": "編輯／文字類人員",
              "no": "220404"
            },
            {
              "des": "技術文件／說明書編譯",
              "no": "220405"
            },
            {
              "des": "校對人員",
              "no": "220406"
            },
            {
              "des": "英文翻譯／口譯人員",
              "no": "220407"
            },
            {
              "des": "日文翻譯／口譯人員",
              "no": "220408"
            },
            {
              "des": "其他語言翻譯／口譯人員",
              "no": "220409"
            },
            {
              "des": "排版人員",
              "no": "220410"
            }
          ]
        }
      ]
    },
    {
      "des": "美編設計",
      "no": "230000",
      "n": [
        {
          "des": "美編設計",
          "no": "230100",
          "n": [
            {
              "des": "設計主管",
              "no": "230101"
            },
            {
              "des": "工業設計",
              "no": "230102"
            },
            {
              "des": "服裝設計",
              "no": "230103"
            },
            {
              "des": "鞋類／皮件設計",
              "no": "230104"
            },
            {
              "des": "多媒體動畫設計師",
              "no": "230105"
            },
            {
              "des": "網頁設計",
              "no": "230106"
            },
            {
              "des": "廣告設計",
              "no": "230107"
            },
            {
              "des": "商業設計",
              "no": "230108"
            },
            {
              "des": "包裝設計",
              "no": "230109"
            },
            {
              "des": "平面設計",
              "no": "230110"
            },
            {
              "des": "美編人員",
              "no": "230111"
            },
            {
              "des": "樣品師",
              "no": "230112"
            },
            {
              "des": "打版人員",
              "no": "230113"
            },
            {
              "des": "設計助理",
              "no": "230114"
            },
            {
              "des": "UI/UX 設計師",
              "no": "230115"
            }
          ]
        }
      ]
    },
    {
      "des": "法務專利／顧問諮詢",
      "no": "240000",
      "n": [
        {
          "des": "法務專利",
          "no": "240100",
          "n": [
            {
              "des": "律師",
              "no": "240101"
            },
            {
              "des": "法務主管",
              "no": "240102"
            },
            {
              "des": "法務人員",
              "no": "240103"
            },
            {
              "des": "代書／地政士",
              "no": "240104"
            },
            {
              "des": "實習律師",
              "no": "240105"
            },
            {
              "des": "法務助理",
              "no": "240106"
            },
            {
              "des": "商標／專利人員",
              "no": "240107"
            },
            {
              "des": "工商登記服務類人員",
              "no": "240108"
            }
          ]
        },
        {
          "des": "顧問諮詢",
          "no": "240200",
          "n": [
            {
              "des": "企管顧問",
              "no": "240201"
            },
            {
              "des": "專業顧問",
              "no": "240202"
            },
            {
              "des": "留學諮詢顧問",
              "no": "240203"
            }
          ]
        }
      ]
    },
    {
      "des": "學術研究／教育師資",
      "no": "250000",
      "n": [
        {
          "des": "自然科學",
          "no": "250100",
          "n": [
            {
              "des": "氣象相關研究人員",
              "no": "250101"
            },
            {
              "des": "地質與地球科學研究人員",
              "no": "250102"
            },
            {
              "des": "天文相關研究人員",
              "no": "250103"
            },
            {
              "des": "應用科學研究人員",
              "no": "250104"
            }
          ]
        },
        {
          "des": "生物理工",
          "no": "250200",
          "n": [
            {
              "des": "數學研究人員",
              "no": "250201"
            },
            {
              "des": "統計學研究人員",
              "no": "250202"
            },
            {
              "des": "生物學專業與研究人員",
              "no": "250203"
            },
            {
              "des": "物理相關研究人員",
              "no": "250204"
            },
            {
              "des": "化學相關研究人員",
              "no": "250205"
            },
            {
              "des": "心理學研究人員",
              "no": "250206"
            },
            {
              "des": "臨床／實驗室研究人員",
              "no": "250207"
            }
          ]
        },
        {
          "des": "人文社會",
          "no": "250300",
          "n": [
            {
              "des": "人類學研究人員",
              "no": "250301"
            },
            {
              "des": "哲學研究人員",
              "no": "250302"
            },
            {
              "des": "社會學研究人員",
              "no": "250303"
            },
            {
              "des": "歷史研究人員",
              "no": "250304"
            },
            {
              "des": "政治相關研究人員",
              "no": "250305"
            }
          ]
        },
        {
          "des": "研究協助",
          "no": "250400",
          "n": [
            {
              "des": "其他研究人員",
              "no": "250401"
            },
            {
              "des": "助理研究人員",
              "no": "250402"
            },
            {
              "des": "研究助理",
              "no": "250403"
            }
          ]
        },
        {
          "des": "教育師資",
          "no": "250500",
          "n": [
            {
              "des": "教授／副教授／助理教授",
              "no": "250501"
            },
            {
              "des": "講師",
              "no": "250502"
            },
            {
              "des": "助教",
              "no": "250503"
            },
            {
              "des": "國小教師",
              "no": "250504"
            },
            {
              "des": "國中教師",
              "no": "250505"
            },
            {
              "des": "高中職教師",
              "no": "250506"
            },
            {
              "des": "特殊教育教師",
              "no": "250507"
            },
            {
              "des": "學校行政人員",
              "no": "250508"
            },
            {
              "des": "校長",
              "no": "250509"
            }
          ]
        }
      ]
    },
    {
      "des": "幼教才藝／補習進修",
      "no": "260000",
      "n": [
        {
          "des": "幼兒教育",
          "no": "260100",
          "n": [
            {
              "des": "園長",
              "no": "260101"
            },
            {
              "des": "教保員",
              "no": "260102"
            },
            {
              "des": "幼教老師",
              "no": "260103"
            },
            {
              "des": "保母／托育人員",
              "no": "260105"
            },
            {
              "des": "托育中心主任／主管",
              "no": "260106"
            }
          ]
        },
        {
          "des": "樂活才藝",
          "no": "260200",
          "n": [
            {
              "des": "音樂老師",
              "no": "260201"
            },
            {
              "des": "美術老師",
              "no": "260202"
            },
            {
              "des": "作文老師",
              "no": "260203"
            },
            {
              "des": "珠心算老師",
              "no": "260204"
            },
            {
              "des": "才藝類老師",
              "no": "260205"
            },
            {
              "des": "烹飪老師",
              "no": "260206"
            },
            {
              "des": "駕訓老師",
              "no": "260207"
            },
            {
              "des": "舞蹈健身老師",
              "no": "260208"
            },
            {
              "des": "游泳教練",
              "no": "260209"
            },
            {
              "des": "運動教練",
              "no": "260210"
            }
          ]
        },
        {
          "des": "補習進修",
          "no": "260300",
          "n": [
            {
              "des": "電腦補習班老師",
              "no": "260301"
            },
            {
              "des": "語文補習班老師",
              "no": "260302"
            },
            {
              "des": "數理補習班老師",
              "no": "260303"
            },
            {
              "des": "升學補習班老師",
              "no": "260304"
            },
            {
              "des": "其他教育類老師",
              "no": "260305"
            },
            {
              "des": "補習班導師",
              "no": "260306"
            },
            {
              "des": "補習班主任／主管",
              "no": "260307"
            },
            {
              "des": "安親班老師",
              "no": "260308"
            },
            {
              "des": "課業輔導老師",
              "no": "260309"
            }
          ]
        }
      ]
    },
    {
      "des": "美容美髮／餐飲旅遊",
      "no": "270000",
      "n": [
        {
          "des": "美容美髮",
          "no": "270100",
          "n": [
            {
              "des": "美容師",
              "no": "270101"
            },
            {
              "des": "美療師／芳療師",
              "no": "270102"
            },
            {
              "des": "美容講師／技導",
              "no": "270103"
            },
            {
              "des": "整體造型師",
              "no": "270104"
            },
            {
              "des": "髮型設計師",
              "no": "270105"
            },
            {
              "des": "美甲彩繪師",
              "no": "270106"
            },
            {
              "des": "寵物美容專業人員",
              "no": "270107"
            },
            {
              "des": "美容助理",
              "no": "270108"
            },
            {
              "des": "美髮助理",
              "no": "270109"
            },
            {
              "des": "美髮講師／技導",
              "no": "270110"
            },
            {
              "des": "美睫師",
              "no": "270111"
            }
          ]
        },
        {
          "des": "餐飲烘焙",
          "no": "270200",
          "n": [
            {
              "des": "餐飲主管",
              "no": "270201"
            },
            {
              "des": "餐飲領班",
              "no": "270202"
            },
            {
              "des": "中式廚師",
              "no": "270203"
            },
            {
              "des": "西式廚師",
              "no": "270204"
            },
            {
              "des": "日式廚師",
              "no": "270205"
            },
            {
              "des": "鐵板燒廚師",
              "no": "270206"
            },
            {
              "des": "中／港式點心廚師",
              "no": "270207"
            },
            {
              "des": "其他料理廚師",
              "no": "270208"
            },
            {
              "des": "西點蛋糕師",
              "no": "270209"
            },
            {
              "des": "麵包師",
              "no": "270210"
            },
            {
              "des": "調酒師／吧台人員",
              "no": "270211"
            },
            {
              "des": "冷熱飲調製人員",
              "no": "270212"
            },
            {
              "des": "餐飲服務人員",
              "no": "270213"
            },
            {
              "des": "餐廚助手",
              "no": "270214"
            },
            {
              "des": "生鮮處理人員",
              "no": "270215"
            },
            {
              "des": "洗碗人員",
              "no": "270216"
            },
            {
              "des": "外送人員",
              "no": "270217"
            }
          ]
        },
        {
          "des": "觀光旅遊",
          "no": "270300",
          "n": [
            {
              "des": "飯店／旅館主管",
              "no": "270301"
            },
            {
              "des": "旅遊休閒類主管",
              "no": "270302"
            },
            {
              "des": "導遊／領隊／導覽",
              "no": "270303"
            },
            {
              "des": "票務人員／旅行社人員",
              "no": "270304"
            },
            {
              "des": "飯店／旅館櫃檯人員",
              "no": "270305"
            },
            {
              "des": "飯店／旅館服務人員",
              "no": "270306"
            },
            {
              "des": "休閒娛樂事業從業人員",
              "no": "270307"
            },
            {
              "des": "遊樂景點工作人員",
              "no": "270308"
            },
            {
              "des": "房務人員",
              "no": "270309"
            }
          ]
        }
      ]
    },
    {
      "des": "生活服務／農林漁牧",
      "no": "280000",
      "n": [
        {
          "des": "生活服務",
          "no": "280100",
          "n": [
            {
              "des": "禮儀師",
              "no": "280101"
            },
            {
              "des": "宗教／神職人員",
              "no": "280102"
            },
            {
              "des": "星象占卜人員",
              "no": "280103"
            },
            {
              "des": "家事服務／洗衣",
              "no": "280106"
            },
            {
              "des": "汽車美容",
              "no": "280107"
            },
            {
              "des": "搬運人員",
              "no": "280108"
            },
            {
              "des": "加油服務",
              "no": "280109"
            },
            {
              "des": "舉牌／傳單／派報員",
              "no": "280110"
            },
            {
              "des": "清潔／資源回收人員",
              "no": "280111"
            },
            {
              "des": "志工／義工類人員",
              "no": "280112"
            },
            {
              "des": "社會工作人員／督導",
              "no": "280114"
            },
            {
              "des": "寵物禮儀師",
              "no": "280115"
            }
          ]
        },
        {
          "des": "農林漁牧",
          "no": "280200",
          "n": [
            {
              "des": "花藝／園藝人員",
              "no": "280201"
            },
            {
              "des": "農藝栽培專業人員",
              "no": "280202"
            },
            {
              "des": "農藝／畜產研究人員",
              "no": "280203"
            },
            {
              "des": "養殖／畜牧專業人員",
              "no": "280204"
            },
            {
              "des": "動物飼育專業人員",
              "no": "280205"
            }
          ]
        }
      ]
    },
    {
      "des": "軍警消防／保全相關",
      "no": "290000",
      "n": [
        {
          "des": "軍警消防",
          "no": "290100",
          "n": [
            {
              "des": "志願役軍官／士官／士兵",
              "no": "290101"
            },
            {
              "des": "公家機關相關人員",
              "no": "290102"
            },
            {
              "des": "消防類相關人員",
              "no": "290103"
            },
            {
              "des": "救生員",
              "no": "290104"
            }
          ]
        },
        {
          "des": "保全相關",
          "no": "290200",
          "n": [
            {
              "des": "總幹事",
              "no": "290201"
            },
            {
              "des": "管理員",
              "no": "290202"
            },
            {
              "des": "隨扈／安全人員",
              "no": "290203"
            },
            {
              "des": "保全人員／警衛",
              "no": "290204"
            },
            {
              "des": "保全工程技術人員",
              "no": "290205"
            }
          ]
        }
      ]
    }
  ]
};

export const mapping = {};

const parse = (src, root) => {
  src.n?.forEach((item) => parse(item));

  mapping[src.no] = src;

  if (root) {
    items.push(src);
  }

  return src;
};

export const toString = (id) => mapping[id].des;

jobCategories.n.forEach((item) => parse(item, true));
